import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import MuiTextField from '@mui/material/TextField'
import type { TextFieldProps, TextFieldVariants } from '@mui/material'

const characterLimitExceededClass = 'character-limit-exceeded'

export const TextField = <
  Variant extends TextFieldVariants = TextFieldVariants,
>({
  value,
  helperText,
  characterLimit,
  errorOnCharacterLimitExceeded,
  slotProps,
  ...props
}: TextFieldProps<Variant> & {
  characterLimit?: number
  errorOnCharacterLimitExceeded?: boolean
}) => {
  const helper =
    characterLimit != null && typeof value === 'string' ? (
      <Stack
        direction="row"
        sx={{
          gap: 1,
        }}
      >
        <Box
          sx={{
            flex: 1,
          }}
        >
          {helperText}
        </Box>
        <Box
          className={
            value.length > characterLimit && errorOnCharacterLimitExceeded
              ? characterLimitExceededClass
              : undefined
          }
          sx={{
            alignSelf: 'flex-end',
          }}
        >
          {value.length} / {characterLimit}
        </Box>
      </Stack>
    ) : (
      helperText
    )

  return (
    <MuiTextField
      value={value}
      slotProps={{
        formHelperText: { component: 'div' },
        ...slotProps,
      }}
      helperText={helper}
      {...props}
    />
  )
}
